import { useParams } from 'react-router-dom'
import Mention from '@tiptap/extension-mention'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import { useMentionUtils } from '../useMentionUtils'
import { PathParams, UseMentionProps } from './useMention.types'

const useMention = ({
  enable,
  mentionConfig,
  onMentionSuccess,
  onMentionError,
  onMentionClick
}: UseMentionProps) => {
  const params = useParams<PathParams>()
  const { getEditorExtension } = useMentionUtils()
  const { community } = useCommunityDetails()

  const communityId = (params?.idCommunity || community?.id) as string
  const mentionsEditorExtensions = enable
    ? [
        Mention.configure(
          getEditorExtension({
            mentionConfig,
            communityId: communityId,
            onMentionSuccess,
            onMentionError,
            onMentionClick
          })
        )
      ]
    : []

  return { mentionsEditorExtensions }
}

export default useMention
